import { Box, Grid, Text, FormControl } from "@chakra-ui/react";
import LabelInput from "./Input";

const Field = ({ label, type, value, error, onChange, min }) => (
  <Box>
    <LabelInput
      label={label}
      type={type}
      value={value || ""}
      isInvalid={!!error}
      onChange={onChange}
      min={min}
    />
    <Box minH="18px">
      {error && (
        <Text fontSize="xs" color="red.500">
          {error}
        </Text>
      )}
    </Box>
  </Box>
);

const DateTimeRange = ({ value, errors, isInvalid, onChange }) => {
  const isSameDaySelected =
    Boolean(value.startDate) &&
    Boolean(value.endDate) &&
    value.startDate === value.endDate;

  return (
    <FormControl isInvalid={isInvalid}>
      <Grid templateColumns="repeat(4, 1fr)" gap={4}>
        <Field
          label="Start Date"
          type="date"
          value={value.startDate}
          error={errors.startDate}
          onChange={(e) => onChange("startDate", e.target.value)}
        />

        <Field
          label="Start Time"
          type="time"
          value={value.startTime}
          error={errors.startTime}
          onChange={(e) => onChange("startTime", e.target.value)}
        />

        <Field
          label="End Date"
          type="date"
          value={value.endDate}
          error={errors.endDate}
          min={value.startDate || undefined}
          onChange={(e) => onChange("endDate", e.target.value)}
        />

        <Field
          label="End Time"
          type="time"
          value={value.endTime}
          error={errors.endTime}
          min={isSameDaySelected ? value.startTime || undefined : undefined}
          onChange={(e) => onChange("endTime", e.target.value)}
        />
      </Grid>
    </FormControl>
  );
};

export default DateTimeRange;
